import React from 'react';
import { useNavigate } from '@thd-olt-component-react/router';
import { ProductDetails } from '@thd-olt-component-react/product-details'
import PropTypes from 'prop-types';
import {
  extend,
  params,
  shape as shapeType,
  string as stringType,
  useDataModel
} from '@thd-nucleus/data-sources';

const ProductDetailsReviewsRatings = ({ itemId, isMobile }) => {
  const navigate = useNavigate();
  const { data, error, loading } = useDataModel('product',
    {
      variables: {
        itemId
      }
    }
  );

  if ((loading && !(data || data?.product?.identifiers)) || error) {
    return null;
  }

  const { canonicalUrl } = data?.product?.identifiers || {};

  const qaLink = (canonicalUrl) ? canonicalUrl.replace('/p/', '/p/questions/') + '/1' : canonicalUrl;

  return (
    <ProductDetails.Ratings
      showBadge
      onClick={() => navigate(qaLink)}
      target="#hydrator-ratings-and-reviews"
      targetURL={qaLink}
      offsetselector="header"
      hideWhenNoQA={!isMobile}
    />
  );
};

ProductDetailsReviewsRatings.dataModel = extend(
  {
    product: params({
      itemId: stringType().isRequired()
    }).shape({
      itemId: stringType(),
      identifiers: shapeType({
        canonicalUrl: stringType(),
      }),
    }),
  },
  ProductDetails.Ratings
);

ProductDetailsReviewsRatings.propTypes = {
  itemId: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired
};

ProductDetailsReviewsRatings.displayName = 'ProductDetailsReviewsRatings';

export default ProductDetailsReviewsRatings;